import {useMutation} from "@tanstack/react-query";
import {removeExpedientResponsibleMutationOptions} from "./remove-expedient-responsible.mutation-options";

export function useRemoveExpedientResponsible(id: string) {
  return useMutation(removeExpedientResponsibleMutationOptions(id));
}
